module.exports = __webpack_public_path__ + "static/img/ui-ux-design-mobile.3b5b515.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/ui-ux-design-mobile.svg
// module id = lLSL
// module chunks = 1